module.exports = __webpack_public_path__ + "img/970204397_1200.fd29d6c4.jpg";